import script from "./TypingGame.vue?vue&type=script&setup=true&lang=js"
export * from "./TypingGame.vue?vue&type=script&setup=true&lang=js"

import "./TypingGame.vue?vue&type=style&index=0&id=32ba6165&lang=css"

const __exports__ = script;

export default __exports__